import { createContext, useContext, useState } from 'react';

interface HookProps {
  isLoading: boolean;
  enableScrollHide: boolean;
  linkSearchSurvey: string;
  setIsLoading: (isLoading: boolean) => void;
  setEnableScrollHide: (enableScrollHide: boolean) => void;
  setLinkSearchSurvey: (linkSearchSurvey: string) => void;
}

const RemoteConfigContex = createContext<HookProps>({} as HookProps);

const RemoteConfigProvider: React.FC<any> = ({ children }) => {
  // Quando for implementado o remote config com firebase, o isLoading será true até que o remote config seja carregado.
  const [isLoading, setIsLoading] = useState(false);

  // Quando for implementado o remote config com firebase, o enableScrollHide será true até que o remote config seja carregado.
  const [enableScrollHide, setEnableScrollHide] = useState(true);

  // Quando for implementado o remote config com firebase, o enableScrollHide será true até que o remote config seja carregado.
  const [linkSearchSurvey, setLinkSearchSurvey] = useState(
    'https://docs.google.com/forms/d/e/1FAIpQLSfBIaYqG-rfRKMEfaCsfc1eO0CFgvUaC5Rq1B3TDqHaaGOCaw/viewform'
  );

  return (
    <RemoteConfigContex.Provider
      value={{
        isLoading,
        enableScrollHide,
        linkSearchSurvey,
        setIsLoading,
        setEnableScrollHide,
        setLinkSearchSurvey,
      }}
    >
      {children}
    </RemoteConfigContex.Provider>
  );
};

const useRemoteConfig = (): HookProps => {
  const ctx = useContext(RemoteConfigContex);

  if (!ctx) throw new Error('Erro ao usar hook RemoteConfig');

  return ctx;
};

export { RemoteConfigProvider, useRemoteConfig };
